import React from "react";
import { Contact, Row } from "../components";

const FormContainer: React.FC = () => (
  <Contact.Form>
    <Contact.Inputs>
      <Row>
        <Contact.Group>
          <Contact.Input placeholder='Name' />
        </Contact.Group>
        <Contact.Group>
          <Contact.Input placeholder='Email' />
        </Contact.Group>
        <Contact.Group>
          <Contact.Input placeholder='Subject' />
        </Contact.Group>
        <Contact.Group>
          <Contact.TextArea placeholder='Message' />
        </Contact.Group>
        <Contact.Group>
          <Contact.Submit type='submit'>Send Message</Contact.Submit>
        </Contact.Group>
      </Row>
    </Contact.Inputs>
  </Contact.Form>
);

export default FormContainer;
